import axios from '@/utils/request';

// 获取我的证书
export const getMyCertificates = (data: any) => {
  return axios.request({
    url: 'Certificate/GetMyCertificates',
    method: 'GET',
    params: data,
  });
};

// 获取证书详情
export const getCertificateDetails = (data: any) => {
  return axios.request({
    url: 'Certificate/GetCertificateDetails',
    method: 'GET',
    params: data,
  });
};
